import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

const sizes = {
    small: {
        maskId: 'mask0_14290_23106',
        viewBox: '0 0 16 16',
        width: '16px',
        height: '16px',
        path: 'M7.3335 11.3335H8.66683V7.3335H7.3335V11.3335ZM8.00016 6.00016C8.18905 6.00016 8.34738 5.93627 8.47516 5.8085C8.60294 5.68072 8.66683 5.52238 8.66683 5.3335C8.66683 5.14461 8.60294 4.98627 8.47516 4.8585C8.34738 4.73072 8.18905 4.66683 8.00016 4.66683C7.81127 4.66683 7.65294 4.73072 7.52516 4.8585C7.39738 4.98627 7.3335 5.14461 7.3335 5.3335C7.3335 5.52238 7.39738 5.68072 7.52516 5.8085C7.65294 5.93627 7.81127 6.00016 8.00016 6.00016ZM8.00016 14.6668C7.07794 14.6668 6.21127 14.4918 5.40016 14.1418C4.58905 13.7918 3.8835 13.3168 3.2835 12.7168C2.6835 12.1168 2.2085 11.4113 1.8585 10.6002C1.5085 9.78905 1.3335 8.92238 1.3335 8.00016C1.3335 7.07794 1.5085 6.21127 1.8585 5.40016C2.2085 4.58905 2.6835 3.8835 3.2835 3.2835C3.8835 2.6835 4.58905 2.2085 5.40016 1.8585C6.21127 1.5085 7.07794 1.3335 8.00016 1.3335C8.92238 1.3335 9.78905 1.5085 10.6002 1.8585C11.4113 2.2085 12.1168 2.6835 12.7168 3.2835C13.3168 3.8835 13.7918 4.58905 14.1418 5.40016C14.4918 6.21127 14.6668 7.07794 14.6668 8.00016C14.6668 8.92238 14.4918 9.78905 14.1418 10.6002C13.7918 11.4113 13.3168 12.1168 12.7168 12.7168C12.1168 13.3168 11.4113 13.7918 10.6002 14.1418C9.78905 14.4918 8.92238 14.6668 8.00016 14.6668ZM8.00016 13.3335C9.48905 13.3335 10.7502 12.8168 11.7835 11.7835C12.8168 10.7502 13.3335 9.48905 13.3335 8.00016C13.3335 6.51127 12.8168 5.25016 11.7835 4.21683C10.7502 3.1835 9.48905 2.66683 8.00016 2.66683C6.51127 2.66683 5.25016 3.1835 4.21683 4.21683C3.1835 5.25016 2.66683 6.51127 2.66683 8.00016C2.66683 9.48905 3.1835 10.7502 4.21683 11.7835C5.25016 12.8168 6.51127 13.3335 8.00016 13.3335Z',
    },
};

export const Info = ({
    color = 'var(--color-neutrals-500)',
    size = 'small',
    height = '16px',
    width = '16px',
    viewBox = '0 0 16 16',
    ...rest
}) => {
    const selectedSize = sizes[size] || sizes.small;
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || selectedSize.width}
            height={height || selectedSize.height}
            viewBox={viewBox || selectedSize.viewBox}
            fill="none"
            {...rest}
        >
            <mask
                id={selectedSize.maskId}
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width={width}
                height={height}
            >
                <rect width={width} height={height} fill="#D9D9D9" />
            </mask>
            <g mask={`url(#${selectedSize.maskId})`}>
                <Path d={selectedSize.path} fill={color} />
            </g>
        </Svg>
    );
};
